import Page from './Page';
import Component from 'vue-class-component';

import template from './Terminal.vue.html';
import TabBar from './TabBar.vue';
import HeaderComponent from './Header.vue';
import { format, isBefore, setHours, setMinutes, subDays } from 'date-fns';
@Component({ template, components: { TabBar, HeaderComponent } })
export default class Terminal extends Page {
    showNotice = false;
    showIssuanceNotice = false;

    async created() {
        await this.app.fetchInfo();
    }

    formatDate(dateTime: string) {
        return format(new Date(dateTime), 'yyyy/MM/dd');
    }

    formatTime(dateTime: string) {
        return format(new Date(dateTime), 'HH:mm');
    }

    getRoomsName() {
        return this.app.reserves_rooms
            .map((rr) => this._(rr.name))
            .filter((name) => name)
            .join(', ');
    }

    setIssueReceiptPage() {
        if (this.app.checkedout) this.app.setPage('IssueReceipt');
        else this.showIssuanceNotice = true;
    }

    showCode() {
        if (this.app.code) this.app.setPage('Code');
        else this.showNotice = true;
    }

    closeNotice() {
        const id = this.app.reserve!.id;
        localStorage?.setItem('Mypage:ShownNotice:' + id, 'true');
        this.showNotice = false;
    }

    showLockstateQr() {
        this.app.setPage('LockstateQr');
    }

    getReserveStatus(): string {
        if (this.app.checkedout) return 'checkedout';
        if (this.app.checkedin) return 'checkedin';
        if (this.app.reserve) return 'not_checked_in';
        return '';
    }

    getGuestName() {
        const firstGuest = this.app.guestList[0];
        const name = firstGuest?.name || firstGuest?.name_kana;
        return name ? this._('honor', name) : '';
    }

    usePayment() {
        if (!this.app.stripe) return false;
        if (this.app.stripe.only_cancellation_fee) return false;
        return !!(this.app.stripe.unpaid || this.app.stripe.modified);
    }

    get displayHouseInfo(): boolean {
        return Boolean(
            this.app.display_house_info || this.app.display_reserve_info
        );
    }

    allowPaymentDate(): Date | null {
        if (this.app.days_before_checkout_payment_allowed === null) return null;
        if (!this.app.reserve) return null;
        const checkout = new Date(this.app.reserve.checkout);
        const timeSetting = this.app.start_time_of_payment_allowed
            ? format(new Date(this.app.start_time_of_payment_allowed), 'HH:mm')
            : '00:00';
        const [hours, minutes] = timeSetting.split(':').map(Number);
        return setHours(
            setMinutes(
                subDays(
                    checkout,
                    this.app.days_before_checkout_payment_allowed
                ),
                minutes
            ),
            hours
        );
    }

    payable() {
        const allowDate = this.allowPaymentDate();
        const isItTimeToPayment = allowDate
            ? isBefore(allowDate, new Date())
            : true;
        return this.usePayment() && isItTimeToPayment;
    }

    clickPaymentButton() {
        if (!this.payable()) {
            const allowPaymentDate = this.allowPaymentDate();
            if (allowPaymentDate) {
                const display_time_of_start_payment = format(
                    allowPaymentDate,
                    'M/d HH:mm'
                );
                alert(
                    this._('start_of_payment', display_time_of_start_payment)
                );
            }
            return;
        }
        this.app.setPage('Billing');
    }

    paymentButtonLabel() {
        if (!this.app.stripe) return '';
        if (!this.app.stripe.unpaid) return this._('payment_history');
        if (this.app.checkedin) return this._('online_payment');
        return this._('prepayment');
    }
}
